module.exports = __webpack_public_path__ + "static/splashscreen-b70e9302158d205e7be2c1ded6a7d6a3.jpg";